<template>
  <div></div>
</template>

<script>
export default {
  name: "VideoPortals",
  beforeCreate() {
    window.location.href = "http://videoportals.whybuyglb.com";
  }
};
</script>

<style>
</style>